import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';

import { isNotNil } from '@malou-io/package-utils';

import { SessionStore } from '#core/store/session.store';

@Injectable()
export class RoleGuard {
    private readonly _router = inject(Router);
    private readonly _sessionStore = inject(SessionStore);

    private readonly _user$ = toObservable(this._sessionStore.user);

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        const expectedRoles = route.data.roles;
        return this._user$.pipe(
            filter(isNotNil),
            take(1),
            map((user) => {
                if (!expectedRoles.includes(user.role)) {
                    this._router.navigate(['/restaurants']);
                    return false;
                }
                return true;
            })
        );
    }
}
